import { Component } from "@angular/core";
import { Platform, NavParams, ViewController } from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";

@Component({
  selector: "edit-cp-user-info-modal",
  templateUrl: "edit-cp-user-info-modal.html",
  providers: [SummaryServiceProvider]
})
export class ChangeUserInfoCpModalComponent {
  data;
  cpName;
  merchantStatusList: any;
  username: any;
  firstName: any;
  lastName: any;
  status: any;
  password: any;

  constructor(
    public platform: Platform,
    public params: NavParams,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    this.data = this.params.get("data");
    this.cpName = this.data.name;
    this.username = this.data.username;
    this.password = "";
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    if (this.data.enabled) {
      this.data.enabled = this.data.enabled == true ? "ACTIVE" : "NOT_ACTIVE";
    }
    this.status = this.data.enabled;
    this.merchantStatusList = [
      { value: "ACTIVE", id: "ACTIVE" },
      { value: "NOT_ACTIVE", id: "NOT_ACTIVE" }
    ];
  }

  compareFn(a, b) {
    return a && b ? a === b : a === b;
  }

  async saveBasicInfo(id) {
    var payload: any = {};
    if (this.data.username !== this.username) {
      payload.username = this.username;
    }
    if (this.password) {
      payload.password = this.password;
    }

    if (this.data.enabled !== this.status) {
      payload.enabled = this.status == "ACTIVE" ? true : "false";
    }
    if (this.data.firstName !== this.firstName) {
      payload.firstName = this.firstName;
    }
    if (this.data.lastName !== this.lastName) {
      payload.lastName = this.lastName;
    }

    console.log("payload", payload);

    if (id) {
      let res = await this.summaryService.updateMerchantUser(id, payload);
      this.viewCtrl.dismiss(true);
    }
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/edit-cp-user-info/edit-cp-user-info-modal.ts